var MDB = window.MDB || {};
MDB.Charts = MDB.Charts || {};
MDB.Charts.renderers = MDB.Charts.renderers || {};

(function () {
    
    function setCssFromString(element, cssString) {
        if (cssString && element && element.length > 0) {
            try {
                var css = {};
                var x = cssString.split(';');
                for (var i = 0; i < x.length; i++) {
                    var y = x[i].split(':');
                    if(y && y[0]) {
                        css[y[0].trim()] = y.length > 1 ? y[1].trim() : '';
                    }
                }
                element.css(css);
            } catch (e) {
                if(console.error) {
                    console.error(e);
                }
            }
        }
        return element;
    }


    function getContent(data) {
        // build html or jquery object
        //console.log(data);
        var fnQueue = [];

        var root = $('<div />');
        var html = '<table border="0" style="width:100%;">';

        for (var i = 0; i < data.length; i++) {
            // display row
            (function (i) {
                var row = data[i];
                var clz = 'cb-row-' + i;

                html += '<tr class="' + clz + '">';
                if (row.LabelInLeftColumn) {
                    html += '<td style="white-space:nowrap;width:10px;" valign="center">';
                    if (row.LabelCss) {
                        html += '<span style="' + row.LabelCss + '">' + row.Label + '</span>';
                    } else {
                        html += row.Label;
                    }
                    html += '</td><td valign="center">';
                } else {
                    html += '<td colspan="2" valign="center">';
                    
                }
                // add bar
                html += '<div class="w-custbar-progress" style="position:relative;">';

                // start outer bar                
                html += '<div class="x-outer" style="' + row.ProgressOuterCss + '">';
                html += '<div class="x-inner" style="' + row.ProgressInnerCss + '">';


                html += '</div>'; // end inner


                if (!row.LabelInLeftColumn) {
                    // add label?
                    html += '<div style="position:absolute;right:10px;z-index:100000; top:0;">';
                    if (row.LabelCss) {
                        html += '<span style="' + row.LabelCss + '">' + row.Label + '</span>';
                    } else {
                        html += row.Label;
                    }
                    html += '</div>';
                }

                html += '</div>'; // end outer

                html += '</div>'; //end wrapper

                html += '</td>';
                html += '</tr>';

                if (row.RowCss) {
                    // set css
                    fnQueue.push(function (el) {
                        el = el.find('.' + clz);
                        setCssFromString(el, row.RowCss);
                        var pbInner = {
                            width: row.Value + '%'
                        };
                        if (row.Value === 0) {
                            pbInner.visibility = 'hidden';
                        }
                        el.find('.x-inner').css(pbInner);                        

                    });
                }

            })(i);
        }

        html += '</table>';
        //console.log(html);
        root.append(html);

        for (var j = 0; j < fnQueue.length; j++) {
            fnQueue[j](root);
        }
        fnQueue = null;
        return root;

    }
    function render(widget, chart, data) {
        // got data: [{"Column1":1,"Name":"Widget T1"}]
        //  convention: first column = value, 2nd column = 5
        if (!data || data.length === 0) {
            widget.find('.loading-box').hide();
            return;
        }
        setTimeout(function () {
            MDB.Charts.emptyChartAndMakeVisible(widget, chart);            

            var content = getContent(data);
            chart.append(content);
            //chart.append(tbl);
        }, 0);

    };


    MDB.Charts.renderers.custom_bars = function (widget, chart, data) {
        render(widget, chart, data, false);
    };
     
})();